// import logo from './logo.svg'
import "./App.css";
import { useLayoutEffect, useState, useEffect } from "react";
import Projects from "./components/projects";
import Intro from "./components/intro";
import { Github, Mail, PhoneCall, Linkedin } from "@geist-ui/react-icons";
import HireMe from "./components/HireMe";
import Reviews from "./components/Reviews";
import ScrollReveal from "scrollreveal";
import Add from "./components/add_proj";
import BlogPosts from "./components/blogPosts";

import { scrollHoriz } from "./components/utils/slider-logic";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import "swiper/css/navigation";

function $(s) {
  return document.getElementById(s);
}
var S = "";
function toggle(s) {
  // xml_request("demo-form","demo_form");
  if ($(s).style.display == "none") {
    $(s).style.display = "flex";
    document.body.style.overflow = "hidden";
    S = s;
  } else {
    S = "";
    $(s).style.display = "none";
    document.body.style.overflowY = "scroll";
  }
}
var ok = false;
// var scroll = true

function smoothScroll() {
  const body = document.body;
  const main = document.getElementById("root");
  let sx = 0, // For scroll positions
    sy = 0;
  let dx = sx, // For container positions
    dy = sy,
    tmp,
    length = 100;
  body.style.height = main.clientHeight + "px";

  main.style.position = "fixed";
  main.style.top = 0;
  main.style.left = 0;
  // Bind a scroll function
  window.addEventListener("wheel", easeScroll);

  function easeScroll(e) {
    // if (scroll) {
    body.style.height = main.clientHeight + "px";

    tmp = sy;
    sy -= (e.wheelDelta / Math.hypot(e.wheelDelta)) * length || 0;
    if (
      sy >=
      document.body.scrollHeight -
        window.innerHeight -
        (e.wheelDelta / Math.hypot(e.wheelDelta)) * length +
        (e.wheelDelta / Math.hypot(e.wheelDelta)) * length
    )
      sy =
        document.body.scrollHeight -
        window.innerHeight -
        (e.wheelDelta / Math.hypot(e.wheelDelta)) * length +
        (e.wheelDelta / Math.hypot(e.wheelDelta)) * length;
    if (sy < 0) sy = 0;
    // }
  }

  window.requestAnimationFrame(render);

  function render() {
    //We calculate our container position by linear interpolation method
    tmp = dy;
    dy = li(dy, sy, 1);
    dy = Math.floor(dy * 100) / 100;
    // main.style.transform = `translate3d(0px, -${dy}px, 0px)`;
    window.requestAnimationFrame(render);
  }

  function li(a, b, n) {
    return (1 - n) * a + n * b;
  }
}

function sendMessage(e) {
  e.preventDefault();

  // console.log(e.children[2].value,e.children[0].value, e.children[1].value)
  //   firebase.functions().httpsCallable('sendMail')({
  //     email: $('client-email').value.toLowerCase(),
  //     subject: $('client-title').value,
  //     text: $('client-message').value,
  //     name: $('client-name').value
  //   })

  //   window.open(
  //     `mailto:ahmedelswerkey@gmail.com?subject=${$('client-title').value}&body=${
  //       $('client-message').value
  //     }`
  $("form-mailto").href = `mailto:ahmedelswerkey@gmail.com?subject=${
    $("client-title").value
  }&body=${$("client-message").value}`;
  //   $('form-mailto').click()
  //   firebase
  //     .firestore()
  //     .collection('messages')
  //     .add({
  //       //   email: $('client-email').value.toLowerCase(),
  //       subject: $('client-title').value,
  //       text: $('client-message').value
  //       //   name: $('client-name').value
  //     })
  $("client-title").value = $("client-message").value = "";
  toggle("demo_form");
  return false;
}

function isInViewport(el, percentVisible) {
  let rect = el.getBoundingClientRect(),
    windowHeight = window.innerHeight || document.documentElement.clientHeight;

  return !(
    Math.floor(100 - ((rect.top >= 0 ? 0 : rect.top) / +-rect.height) * 100) <
      percentVisible ||
    Math.floor(100 - ((rect.bottom - windowHeight) / rect.height) * 100) <
      percentVisible
  );
}

function App() {
  const [showAdd, setShowAdd] = useState(false);
  const [countAdd, setCountAdd] = useState(0);
  // ScrollReveal().reveal('.item', {
  //   origin: 'top',
  //   distance: '100px',
  //   reset: true,
  //   delay: 150
  // })
  useEffect(() => {
    let date = new Date();

    console.log(
      `%c Welcome to my Portfolio Console!
    %c It\'s a pleasure that you\'re interested in my work;
    %c I\'ve been occasionally tweaking this portfolio since day one of hearing about "the WEB",
    %c which is since mid 2015, ${date.getFullYear() - 2015} Years ago,
    %c And what a journey it has been. the Web field is really powerful and has so much potential!`,
      "color: #ff8a8a; font-size: 2rem;",
      "color: #5a7afa; font-size: 1.7rem;",
      "color: #6aea8a; font-size: 1.5rem;",
      "color: #8e6ce8; font-size: 1.5rem;",
      "color: #f7fb4f; font-size: 1.5rem;"
    );
    // console.log('%c It\'s a pleasure that you\'re interested in my work!', 'color: #5a7afa; font-size: 1.7rem;')
    // console.log('%c Well, I\'ve been occasionally tweaking this portfolio since day one of hearing about "the WEB"', 'color: #6aea8a; font-size: 1.5rem;')
    // console.log('%c which is since mid 2015, '+(date.getFullYear() - 2015)+' Years ago', 'color: #8e6ce8; font-size: 1.5rem;')
    // console.log('%c And what a jounrye it has been. the Web field is really powerful and has so much potential!', 'color: #f7fb4f; font-size: 1.5rem;')

    let reviews = document.getElementById("slider-items"),
      blogPosts = document.getElementById("blog-posts");

    // console.log(reviews,
    //   blogPosts);

    // if(blogPosts)
    //   scrollHoriz(blogPosts)

    if (reviews) scrollHoriz(reviews.parentElement.parentElement);
  }, []);

  useEffect(() => {
    if (countAdd == 3) setShowAdd(true);
  }, [countAdd]);
  return (
    <>
      <input type="radio" name="proj" id="work" defaultChecked />
      {/* <input type='radio' name='proj' id='all' />
        <input type='radio' name='proj' id='personal' />
        <div id='filters'>
            <label htmlFor='all'>🤩 All</label>
            <label htmlFor='personal'>🤡 Demo sites</label>
            <label htmlFor='work'>😎 Past projects</label>
        </div> */}
      <div className="item">
        <Intro countAdd={countAdd} setCountAdd={(e) => setCountAdd(e)} />
        {showAdd && (
          <Add
            cleanup={() => {
              setShowAdd(false);
              setCountAdd(0);
            }}
          />
        )}
      </div>
      <div className="item">
        <Projects />
      </div>
      <div className="item">
        <Reviews />
      </div>
      <div className="item">
        <BlogPosts />
      </div>
      <div className="item">
        <HireMe />
      </div>
    </>
  );
}

export default App;

/*
    //--A function that tests if the slider element is in view
    function isInViewport (el) {
    if (typeof jQuery === 'function' && el instanceof jQuery) {
        el = el[0]
    }
    //---Getting the document position values
    var rect = el.getBoundingClientRect()
    //---Retuning true if the element is nearly at the top of the viewed page, or nearly at the bottom
    return (
        rect.top + window.innerHeight / 9 >= 0 &&
        rect.bottom - window.innerHeight / 9 <=
        (window.innerHeight || document.documentElement.clientHeight)
    )
    }

    //---A function that scrolls the slider depending on the mouse wheel movement
    function horizontal (e) {
    if (String(e) != '+' || String(e) != '-') {
        //---Getting the value of the mouse scroll
        e = window.event || e
        //---The scroll value calculated from the mouse events
        var delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail))
        slider.scrollLeft -= delta * 65
    }
    console.log(e)

    if (e == '-' || e.key == 'ArrowUp') slider.scrollLeft -= 65
    if (e == '+' || e.key == 'ArrowDown') slider.scrollLeft += 65

    //---Testing if the element is scrolled to max if the mouse is scrolling down, or to the minimum if mouse if scrolling up
    if (
        (slider.scrollLeft == slider.scrollWidth - slider.offsetWidth &&
        e.wheelDelta < 0) ||
        (slider.scrollLeft == 0 && e.wheelDelta > 0)
    ) {
        //---Enabling the page scroll
        document.body.style.overflow = 'auto'
    }
    }
    //---Implementing the listeners when the page loads
    window.onload = () => {
    var slider = document.getElementById('slider-contain')
    var sliderMain = document.getElementById('slider')

    //---Listening to the page scroll
    document.addEventListener('scroll', e => {
        //---Testing if the slider element is in view
        if (isInViewport(sliderMain)) {
        //---If is in view, Scroll to it and make the element aligned to the page view
        sliderMain.scrollIntoView()
        //---Making sure the element is aligned and displayed to user correctly by using hash and element id
        document.location.hash = '#slider'
        //---Disabling the page scrolling
        document.body.style.overflow = 'hidden'
        //---Adding a scroll function to the page that scroll horizontally
        document.addEventListener('mousewheel', horizontal, false)
        document.addEventListener('keydown', function (ee) {
            if (ee.keyCode === 38) {
            // up
            horizontal('-')
            }
            if (ee.keyCode === 40) {
            // down
            horizontal('+')
            }
            e.preventDefault()
        })
        //---Firefox Listener compitability
        document.addEventListener('DOMMouseScroll', horizontal, false)
        } else {
        //---Removing the listeners from the document, which scrolls horizontally
        document.removeEventListener('mousewheel', horizontal)
        // Firefox
        document.removeEventListener('DOMMouseScroll', horizontal)
        }
    })
    }
*/
